// const API_BASE_URL = 'https://rollcallapis.azurewebsites.net/';

const API_BASE_URL = "https://perecoapi.cloudrollcall.in/portal/";
// const API_BASE_URL = "http://qaperecoapi.runasp.net/portal/";

export { API_BASE_URL };
